let today = new Date();
today.setHours(0, 0, 0, 0);

export { today };
